<ng-container *ngIf="isMandatory">
  <p class="internal-info">Internal Use Only</p>
  <p class="card-info">This section is for internal purposes.</p>
</ng-container>
<form [formGroup]="internalDetailsFormGroup" class="internal-form" fxLayout="column">
  <div fxLayout="row" fxLayoutGap="30px">
    <div fxLayout="column" fxFlex="100">
        <mat-label> {{isMandatory ? '* Officer Code:':'Officer Code'}}</mat-label>
        <div class="form-input">
          <mat-form-field appearance="outline">
            <mat-select placeholder="Officer Code" 
                       formControlName="officerCode" 
                       autocomplete="officer-code"
                       (selectionChange)="onOfficerCodeChange($event.value)">
              <mat-option value="">--Select--</mat-option>
              <mat-option *ngFor="let officer of officerCodeData" 
                         [value]="officer.officerCode">
                {{officer.officerCode}} - {{officer.officerName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    <div fxLayout="column" fxFlex="100">
      <mat-label> {{isMandatory ? '* Branch ID:':'Branch ID'}}</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="costCenter" maxlength="3" readonly>
      </mat-form-field>
    </div>
  </div>
</form>
